import { Slider, Tooltip, Box } from '@mui/material';
import React, { useState } from 'react';
import { WsTypography, WsTypoVariants } from 'wisestep-base';

export interface MarkValueProps {
  value: number;
  label: string;
}

interface WsCustomSliderProps {
  marks: MarkValueProps[];
  title?: string;
  onChange: (newValue: number[]) => void;
  min: number;
  max: number;
  value: number[];
}

const WsCustomRangeSlider: React.FC<WsCustomSliderProps> = ({
  marks,
  value,
  title = 'Customize Range Slider',
  onChange,
  min,
  max,
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  return (
    <Box sx={{ px: 2 }}>
      <WsTypography variant={WsTypoVariants.BODY1} bold>
        {title}
      </WsTypography>
      <Tooltip title={`${value[0]}% - ${value[1]}%`} open={tooltipOpen} placement="top">
        <Slider
          value={value}
          onChange={(_, value) => onChange(value as number[])}
          onMouseEnter={() => setTooltipOpen(true)}
          onMouseLeave={() => setTooltipOpen(false)}
          marks={marks}
          min={min}
          max={max}
          step={null}
          disableSwap
          sx={{
            '& .MuiSlider-thumb': {
              width: 18,
              height: 18,
              bgcolor: 'primary.main',
              '&:hover': { boxShadow: '0px 0px 8px rgba(0, 0, 255, 0.5)' },
            },
            '& .MuiSlider-mark': {
              backgroundColor: 'primary.light',
              height: 10,
              width: 10,
              borderRadius: '50%',
            },
            '& .MuiSlider-markLabel': {
              fontSize: '0.6rem',
              transform: 'translateX(-40%)',
              color: 'gray',
            },
          }}
        />
      </Tooltip>
    </Box>
  );
};

export default WsCustomRangeSlider;
